import { Injectable } from '@angular/core';
import { SpinnerService } from './spinner.service';
import { Router } from '@angular/router';
import { HttpEvent, HttpHandler, HttpRequest } from '@angular/common/http';
import { Observable } from 'rxjs';
import {finalize } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class InterceptorService {

  constructor(private spinnerService:SpinnerService,
    private router:Router
) { }

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    this.spinnerService.llamarSpinner();

    return next.handle(req).pipe(
      finalize(()=>{
        this.spinnerService.detenerSpinner();
      })
    )
  }
}
